import { useState, useEffect } from 'react'
import axios from 'axios'
import Image from "next/legacy/image";
import styled from 'styled-components'

import { StyledButton } from 'src/styles/Button'
import { H3 } from 'src/styles/Typography'

const specialty = [
  { value: 'life', name: 'Life Insurance' },
  { value: 'auto', name: 'Auto Insurance' },
  { value: 'health', name: 'Health Insurance' },
  { value: 'medicare', name: 'Medicare Insurance' },
]

const isMissing = (value) => value == null || value === ''

const AgentsFormPortal = ({ setClose, position }) => {
  const [error, setError] = useState(false)
  const [loading, setLoading] = useState(false)
  const [success, setSuccess] = useState(false)
  const [form, setForm] = useState({
    specialty: '',
    first_name: '',
    last_name: '',
    email: '',
    phone: '',
  })

  const [file, setFile] = useState(null)

  useEffect(() => {
    if (position) {
      setForm({ ...form, specialty: position })
    }
  }, [form, position])

  const submit = async () => {
    const text = `<h3>Submission from Agent Careers page</h3><p><strong>Specialty:</strong> ${form.specialty}</p><p><strong>First Name:</strong> ${form.first_name}</p><p><strong>Last Name:</strong> ${form.last_name}</p><p><strong>Phone:</strong> ${form.phone}</p>`

    const formData = new FormData()
    formData.append('file', file, file.name)
    formData.append('text', text)

    await axios({
      method: 'post',
      url: 'https://48ct1d2shj.execute-api.us-east-1.amazonaws.com/prod/v1/submit',
      data: formData,
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
      .then(() => {
        setSuccess(true)
      })
      .finally(() => {
        setLoading(false)
      })
  }

  const getAllNonFilledFields = () => {
    const fields = Object.keys(form)
    const missing = fields.filter((field) => isMissing(form[field]))
    return missing
  }

  const handleSetForm = ({ target: { name, value } }) => {
    setForm((form) => ({ ...form, [name]: value }))
  }

  const handleSubmit = (e) => {
    e.preventDefault()

    setError(false)
    setSuccess(false)
    setLoading(true)

    const nonFilledFields = getAllNonFilledFields()
    if (nonFilledFields.length || !file) {
      setLoading(false)
      return setError('All fields are required')
    }

    submit()
  }
  return (
    <FormPortal>
      <TopCloseBttn onClick={() => setClose(true)}>Close</TopCloseBttn>
      <Container>
        <Left>
          <Image
            src={'/images/agent-portal.jpeg'}
            quality={30}
            width={'400'}
            height={'400'}
            alt={'title'}
            aria-label={'description'}
            priority
          />
          <LeftContent>
            <h5>Requirements:</h5>
            <ul>
              <li>Valid National Producer Number (NPN)</li>

              <li>
                At least 10 coinciding life (and health) insurance state licenses (the
                more the better)
              </li>

              <li>1+ years of phone sales experience</li>

              <li>A high-speed internet connection and reliable computer</li>

              <li>Headset with a microphone</li>

              <li>
                Working space and equipment that comply with HIPAA privacy and security
                standards
              </li>
            </ul>
          </LeftContent>
        </Left>
        <Right>
          <H3>Apply Today and Become PolicyScout Insurance Agent</H3>
          <Form onSubmit={handleSubmit}>
            {success ? (
              <H3>Success!</H3>
            ) : (
              <>
                <label htmlFor="specialty">
                  <span>Your Specialty</span>
                  <select
                    name="specialty"
                    id="specialty"
                    value={form.specialty}
                    onChange={handleSetForm}
                  >
                    <option disabled value="" />
                    {specialty.map((x) => (
                      <option key={x.value} name="specialty" value={x.value}>
                        {x.name}
                      </option>
                    ))}
                  </select>
                </label>

                <label htmlFor="first_name">
                  <span>First Name</span>
                  <input
                    id="first_name"
                    type="text"
                    name="first_name"
                    onChange={handleSetForm}
                    value={form.first_name}
                  />
                </label>

                <label htmlFor="last_name">
                  <span>Last Name</span>
                  <input
                    id="last_name"
                    type="text"
                    name="last_name"
                    onChange={handleSetForm}
                    value={form.last_name}
                  />
                </label>

                <label htmlFor="email">
                  <span>Email</span>
                  <input
                    id="email"
                    type="text"
                    name="email"
                    onChange={handleSetForm}
                    value={form.email}
                  />
                </label>

                <label htmlFor="phone">
                  <span>Phone Number</span>
                  <input
                    id="phone"
                    type="text"
                    name="phone"
                    onChange={handleSetForm}
                    value={form.phone}
                  />
                </label>

                <label htmlFor="upload-resume">
                  <span>Upload Resume</span>
                  <input
                    id="upload-resume"
                    type="file"
                    onChange={(e) => setFile(e.target.files[0])}
                  />
                </label>

                <RequiredInformation>* Required Information</RequiredInformation>
              </>
            )}
            {error && <Error>{error}</Error>}
            {!success && <AgentsApplyBttn>Apply</AgentsApplyBttn>}
            <Legal>
              By clicking &#34;Start Selling&#34; I hereby consent to receive
              communication from PolicyScout, GuideToInsure, InsureaLife including email,
              SMS, and phone.
            </Legal>
          </Form>
        </Right>
      </Container>
    </FormPortal>
  )
}

export default AgentsFormPortal

const Error = styled.div`
  margin-bottom: 1em;
  text-align: center;
`

const FormPortal = styled.div`
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  max-width: 774px;
  background: white;
  z-index: 1000;
  box-shadow: 0 10px 16px 0 rgba(0, 0, 0, 0.15);
  border: solid 6px #40d1ff;
  @media (max-width: 759px) {
    overflow-y: scroll;
    width: 100%;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    transform: unset;
  }
`

const Container = styled.div`
  display: grid;
  grid-template-columns: 349px 382px;

  @media (max-width: 759px) {
    grid-template-columns: 100%;
  }
`
const TopCloseBttn = styled.button`
  position: absolute;
  top: -38px;
  right: -6px;
  background: #40d1ff;
  color: white;
  border: unset;
  font-weight: 500;
  text-align: center;
  // border-radius: 4px 0 4px 4px;
  cursor: pointer;
  width: 64px;
  line-height: 30px;
  font-size: 13px;
  font-weight: bold;

  &:hover {
    background: darken(#40d1ff, 5%);
  }

  @media (max-width: 759px) {
    top: 0;
    right: 0;
    z-index: 30;
  }
`

const LeftContent = styled.div`
  position: relative;
  margin-top: -1rem;
  z-index: 10;
  margin-bottom: 33px;
`

const Left = styled.div`
  h5 {
    font-size: 14px;
    font-weight: bold;
    color: #252525;
    padding-left: 2em;
  }

  ul,
  ol {
    font-family: Libre Baskerville;
    font-size: 12px;
    line-height: 1.33;
    color: #606060;
    padding-left: 3.5em;
    padding-right: 2.7em;

    list-style-type: disc;
    list-style-image: url('./list-style-image.svg');

    li {
      margin-top: 1.5em;
    }
  }

  @media (max-width: 759px) {
    display: none;
  }
`

const Right = styled.div`
  padding: 30px;
  box-shadow: -1px 0 0 0 #ededed;
  z-index: 2;

  h3 {
    font-size: 23px;
    font-weight: 800;
    color: #252525;
  }
`

const Form = styled.form`
  label {
    display: flex;
    flex-direction: column;

    & + label {
      margin-top: 1.5rem;
    }
    span {
      font-size: 14px;
      font-weight: 600;
      color: #606060;
      margin-bottom: 8px;

      &:after {
        content: '*';
        color: #e7582c;
        padding-left: 5px;
      }
    }

    input,
    select {
      height: 36px;
      border: solid 1px #dcdcdc;
      background-color: #ffffff;
      width: 100%;
      padding: 0 13px;
      font-size: 16px;

      &:focus {
        outline: 1px solid lighten(#e7582c, 5%);
      }
    }

    input[type='file'] {
      color: black;
      cursor: pointer;
    }

    select {
      appearance: none;
      background-image: url('src/images/newLanding/select-arrows.svg');
      background-repeat: no-repeat;
      background-position-x: 85%;
      background-position-x: calc(100% - 0.75em);
      background-position-y: 50%;
    }
  }

  button {
    display: inline-block;
    height: 44px;
    width: 100%;
    font-size: 16px;
    min-height: auto;

    &.success {
      background: green;
      border: 2px solid green;
    }
  }
`

const Legal = styled.div`
  margin-top: 12px;
  font-size: 12px;
  line-height: 1.33;
  color: #adadad;
`

const RequiredInformation = styled.div`
  font-size: 12px;
  color: #e7582c;
  margin: 1em 0;
`

const AgentsApplyBttn = styled(StyledButton)`
  display: inline-block;
  height: 44px;
  width: 100%;
  font-size: 16px;
  min-height: auto;

  &.success {
    background: green;
    border: 2px solid green;
  }
`
